import { Component, OnInit, Inject, PLATFORM_ID, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { filter, take } from 'rxjs/operators';
import {
  IgxCategoryChartModule,
  IgxPieChartModule,
  IgxItemLegendModule,
  IgxLegendModule,
} from 'igniteui-angular-charts';
import { ReportsIntergrationService } from '../services/reports-intergration.service';
import { KeycloakAuthService } from '../services/keycloak-auth.service';
import { HttpHelperService } from '../services/helper.service';
import { ReportsBaseService } from '../services/reports-base.service';
import { KitsoReportComponent } from './kitso-report/kitso-report.component';
import { MpiloReportComponent } from './mpilo-report/mpilo-report.component';
import { LesediReportComponent } from './lesedi-report/lesedi-report.component';
import { LwaziReportComponent } from './lwazi-report/lwazi-report.component';
import { KitsoecdReportComponent } from './kitsoecd-report/kitsoecd-report.component';
import { KitsoaiReportComponent } from './kitsoai-report/kitsoai-report.component';
import { KitsozaziReportComponent } from './kitsozazi-report/kitsozazi-report.component';

@Component({
  selector: 'app-reports-integration',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    IgxCategoryChartModule,
    IgxPieChartModule,
    IgxItemLegendModule,
    IgxLegendModule,
    RouterModule,
    KitsoReportComponent,
    MpiloReportComponent,
    LesediReportComponent,
    LwaziReportComponent,
    KitsoecdReportComponent,
    KitsoaiReportComponent,
    KitsozaziReportComponent,
  ],
  templateUrl: './reports-integration.component.html',
  styleUrls: ['./reports-integration.component.scss']
})
export class ReportsIntegrationComponent implements OnInit {
  availableBots: any[] = [];
  selectedBot: string = '';
  isLoading = false;
  error: string | null = null;

  constructor(
    private reportsBaseService: ReportsBaseService,
    private authService: KeycloakAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.syncSelectedBotWithUrl();
    });
  }

  ngOnInit(): void {
    this.checkUserBotAccess();

  }

  ngAfterViewInit(): void {
    const section = this.route.snapshot.paramMap.get('section');
    if (!section) {
      return;
    }

    this.selectedBot = section
  }


  private checkUserBotAccess(): void {
    this.isLoading = true;
    this.error = null;

    const user = this.authService.currentUserValue();
    if (user && user.roles) {
      this.processUserBotAccess(user);
      return;
    }
    this.authService.currentUser$
      .pipe(
        filter((u: any) => !!u && !!u.roles),
        take(1)
      )
      .subscribe({
        next: (u: any) => {
          this.processUserBotAccess(u);
        },
        error: (err) => {
          console.error('Error fetching user data:', err);
          this.error = "Failed to load user data. Please try logging in again.";
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  private processUserBotAccess(user: any): void {
    const botRoles = user.roles.filter((role: string) => role.startsWith('bot_access_'));

    this.availableBots = botRoles.map((role: string) => {
      const botName = role.replace('bot_access_', '');
      return {
        key: botName,
        name: botName.charAt(0).toUpperCase() + botName.slice(1)
      };
    });

    if (this.availableBots.length > 0) {
      const currentChild = this.route.firstChild?.snapshot.url[0]?.path;
      const isCurrentBotAllowed = currentChild && this.availableBots.some(b => b.key === currentChild);
      if (isCurrentBotAllowed) {
        this.selectedBot = currentChild!;
      } else {
        this.selectBot(this.availableBots[0].key);
      }
    } else {

      this.error = "You do not have access to any bots. Please contact an administrator.";
    }

    this.isLoading = false;
    this.cdr.detectChanges();
  }

  selectBot(botKey: string) {
    console.log('begining the selectBot')
    this.selectedBot = botKey;
    this.reportsBaseService.clearData();

    if (!this.selectedBot) {
      return;
    }

    this.router.navigate(
      [`reports/${botKey}`],
      { relativeTo: this.route }
    )

    const section = this.route.snapshot.paramMap.get('section');
    
    if (!section) {
      return;
    }
    this.selectedBot = section;
  }

  private syncSelectedBotWithUrl(): void {
    const currentChild = this.route.firstChild?.snapshot.url[0]?.path;
    if (currentChild && this.availableBots.some(b => b.key === currentChild)) {
      this.selectedBot = currentChild;
    }
  }
}